<template>
    <div class="componentsCtn">
        <div class="mainCtn">
            <div class="topCtn">
                <span @click="$router.push('/')" style="cursor:pointer">首页/</span><span style="color:#3A3A3A;">个人中心</span>
            </div>
            <div style="width:100%;height: auto;display: flex;justify-content: space-between">
                <div class="menuPanel">
                    <div @click="chooseItem(1)" :class="['menuItem',,selectedItem==1 ? 'goldMode':'']" style="margin-top: 7px;">
                        <div class="menuItem_png">
                            <img v-if="selectedItem==1" src="../assets/userCenter/我的报名_金.png" height="16" width="18" align="baseline" style="margin-bottom: -2px"/>
                            <img v-else src="../assets/userCenter/我的报名_黑.png" height="16" width="18" align="baseline" style="margin-bottom: -2px"/>
                        </div>
                        我的报名
                    </div>
                    <div @click="chooseItem(2)" :class="['menuItem',,selectedItem==2 ? 'goldMode':'']">
                        <div class="menuItem_png">
                            <img v-if="selectedItem==2" src="../assets/userCenter/我的课程_金.png" height="16" width="18" align="baseline" style="margin-bottom: -2px"/>
                            <img v-else src="../assets/userCenter/我的课程_黑.png" height="16" width="18" align="baseline" style="margin-bottom: -2px"/>
                        </div>
                        我的课程
                    </div>
                    <div @click="chooseItem(3)" :class="['menuItem',,selectedItem==3 ? 'goldMode':'']">
                        <div class="menuItem_png">
                            <img v-if="selectedItem==3" src="../assets/userCenter/我的作业_金.png" height="16" width="18" align="baseline" style="margin-bottom: -2px"/>
                            <img v-else src="../assets/userCenter/我的作业_黑.png" height="16" width="18" align="baseline" style="margin-bottom: -2px"/>
                        </div>
                        我的作业
                    </div>
                    <div @click="chooseItem(4)" :class="['menuItem',,selectedItem==4 ? 'goldMode':'']">
                        <div class="menuItem_png">
                            <img v-if="selectedItem==4" src="../assets/userCenter/我的消息_金.png" height="16" width="18" align="baseline" style="margin-bottom: -2px"/>
                            <img v-else src="../assets/userCenter/我的消息_黑.png" height="16" width="18" align="baseline" style="margin-bottom: -2px"/>
                        </div>
                        我的消息
                    </div>

                </div>
                <div class="contentCtn" >
                    <SignUp v-if="selectedItem==1"></SignUp>
                    <Lession v-if="selectedItem==2"></Lession>
                    <Task v-if="selectedItem==3"></Task>
                    <Message v-if="selectedItem==4"></Message>
                </div>
            </div>
        </div>
    </div>

    
</template>

<script>
    import SignUp from "./userCenter/signUp"
    import Lession from "./userCenter/lession"
    import Task from "./userCenter/task"
    import Message from "./userCenter/message"
    export default {
        name: "universityUserCenter",
        components:{
            SignUp,Lession,Task,Message
        },
        data(){
            return{
                selectedItem:1,

            }
        },
        methods:{
            chooseItem:function(data){
                this.selectedItem=data;
                this.$router.push({path:'universityUserCenter',query:{'type':data,'c':data}});
            },

        },
        mounted(){
            console.log('router参数')
            console.log(this.$route.query)
            let itemType=this.$route.query.type;
            if(itemType){
                this.selectedItem=itemType
            }

        }
    }
</script>

<style scoped>
    .contentCtn{
        width: 1105px;
        min-height: 660px;
        background: #FFFFFF;
        border-radius: 16px;
    }
    .menuItem_png{
        display: inline-block;
        width: 18px;
        height: 16px;
        margin-left: 22px;
        margin-right: 10px;
    }
    .menuItem{
        margin-top:3px;
        width: 147px;
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3A3A3A;
        margin-left: auto;
        margin-right: auto;
        border-radius: 8px;
        cursor:pointer;
    }
    .goldMode{
        color: #C49760;
        background: rgba(196,151,96,0.1);
    }
    .menuItem:hover{
        background: rgba(196,151,96,0.1);
    }
    .menuPanel{
        width: 160px;
        height: 224px;
        background: #FFFFFF;
        border-radius: 16px;
    }
    .topCtn{
        width: 100%;
        height: 102px;
        margin-top: 120px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #979797;
        line-height: 102px;
    }
    .mainCtn{
        position:relative;
        width: 1280px;
        min-height: 960px;
        margin-right: auto;
        margin-left: auto;
        background: #F5F5F6;
    }
    .componentsCtn{
        width: 100%;
        min-height: 960px;
        background: #F5F5F6;

    }

</style>